(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAnnVideo() {
      var body = document.querySelector('.ann__body');
      if (!body) return;
      var v = body.querySelector('video');
      if (!v || v.dataset.annReady) return;
      v.dataset.annReady = '1';

      // No native player, no sound — just a play button
      v.removeAttribute('controls');
      v.muted = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('preload', 'metadata');
      v.removeAttribute('style');

      var wrap = document.createElement('div');
      wrap.className = 'ann__video';
      v.parentNode.insertBefore(wrap, v);
      wrap.appendChild(v);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ann__video-btn';
      btn.setAttribute('aria-label', 'Lire la vidéo');
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';
      wrap.appendChild(btn);

      function play() { v.muted = true; var p = v.play(); if (p && p.catch) { p.catch(function () {}); } }
      function toggle() { if (v.paused) { play(); } else { v.pause(); } }

      btn.addEventListener('click', function (e) { e.preventDefault(); toggle(); });
      v.addEventListener('click', toggle);
      v.addEventListener('play', function () { wrap.classList.add('is-playing'); });
      v.addEventListener('pause', function () { wrap.classList.remove('is-playing'); });
      v.addEventListener('ended', function () { wrap.classList.remove('is-playing'); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAnnVideo);
    } else {
      initAnnVideo();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avis-wall"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-section-type="avis-wall"]');
    sections.forEach(function (root) {
      if (root.dataset.avwReady) return;
      root.dataset.avwReady = '1';

      var wall = root.querySelector('.avw__wall');
      var allTiles = Array.prototype.slice.call(wall.querySelectorAll('.avw-tile'));
      var pills = Array.prototype.slice.call(root.querySelectorAll('.avw-pill'));
      var moreBtn = root.querySelector('.avw__more-btn');
      var emptyMsg = root.querySelector('.avw__empty');

      var initCount = parseInt(root.dataset.init, 10) || 12;
      var stepCount = parseInt(root.dataset.step, 10) || 8;

      var filter = 'all';
      var shown = initCount;

      // Switch from the CSS-columns fallback to real flex columns.
      wall.classList.add('avw__wall--js');

      function matches(tile) {
        var t = tile.getAttribute('data-type');
        // CTA tiles belong to every category so the purchase path is always present.
        return filter === 'all' || t === filter || t === 'cta';
      }

      function colCount() {
        var w = wall.clientWidth || root.clientWidth || window.innerWidth;
        if (w >= 1560) return 5;
        if (w >= 1040) return 4;
        if (w >= 640) return 3;
        return 2;
      }

      // Shortest-column masonry, split into a full REBUILD (init / filter /
      // resize) and an incremental REVEAL. Reveal only ever APPENDS the newly
      // shown tiles to the existing columns, so "Charger plus" can never move a
      // tile that's already on screen — no jump, no reshuffle.
      var colEls = [];
      var heights = [];
      var curList = [];
      var placed = 0;

      function shortest() {
        var min = 0;
        for (var j = 1; j < colEls.length; j++) {
          if (heights[j] < heights[min]) min = j;
        }
        return min;
      }
      function place(tile) {
        var c = shortest();
        colEls[c].appendChild(tile);
        heights[c] += tile.offsetHeight + 18;
      }
      function updateMore() {
        if (moreBtn) moreBtn.hidden = curList.length <= shown || curList.length === 0;
        if (emptyMsg) emptyMsg.hidden = curList.length !== 0;
      }

      function rebuild() {
        curList = allTiles.filter(matches);
        var cols = colCount();
        wall.textContent = '';
        colEls = [];
        heights = [];
        for (var i = 0; i < cols; i++) {
          var c = document.createElement('div');
          c.className = 'avw__col';
          wall.appendChild(c);
          colEls.push(c);
          heights.push(0);
        }
        placed = 0;
        reveal();
      }

      function reveal() {
        var target = Math.min(shown, curList.length);
        for (var i = placed; i < target; i++) place(curList[i]);
        placed = target;
        updateMore();
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) { p.classList.remove('is-active'); p.setAttribute('aria-pressed', 'false'); });
          pill.classList.add('is-active');
          pill.setAttribute('aria-pressed', 'true');
          filter = pill.getAttribute('data-filter');
          shown = initCount;
          rebuild();
        });
      });

      if (moreBtn) {
        moreBtn.addEventListener('click', function () {
          shown += stepCount;
          reveal();
        });
      }

      // Inline video play / pause — one at a time. Listeners live on the tile
      // elements, which persist across re-distribution.
      var current = null;
      allTiles.forEach(function (tile) {
        var media = tile.querySelector('[data-video]');
        if (!media) return;
        var video = media.querySelector('video');
        if (!video) return;
        function toggle() {
          if (video.paused) {
            if (current && current !== video) {
              current.pause();
              var prev = current.closest('.avw-video__media');
              if (prev) prev.classList.remove('is-playing');
            }
            video.play();
            media.classList.add('is-playing');
            current = video;
          } else {
            video.pause();
            media.classList.remove('is-playing');
          }
        }
        media.addEventListener('click', toggle);
        media.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
        });
        video.addEventListener('ended', function () { media.classList.remove('is-playing'); });
      });

      // Re-pack on resize only when the column count actually changes —
      // debounced — so a stable width never disturbs the layout.
      var rAF = null;
      var lastCols = colCount();
      window.addEventListener('resize', function () {
        if (rAF) return;
        rAF = window.requestAnimationFrame(function () {
          rAF = null;
          var c = colCount();
          if (c !== lastCols) { lastCols = c; rebuild(); }
        });
      });

      rebuild();
      // Re-pack once fonts/media have loaded so heights are exact (fires before
      // any interaction, so it never moves a tile out from under the user).
      window.addEventListener('load', rebuild);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-section-type="before-after"]').forEach(function (section) {
    var stage = section.querySelector('[data-ba]');
    var range = section.querySelector('[data-ba-range]');
    if (!stage || !range) return;
    function set(v) { stage.style.setProperty('--pos', v + '%'); }
    range.addEventListener('input', function () { set(range.value); });
    set(range.value);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-ugc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var cards = document.querySelectorAll('[data-cu-video]');
    if (!cards.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var items = [];

    /* ── Desktop slider: prev/next arrows + click-drag to scroll ──
       The grid is a horizontal overflow scroller. Mouse users get no scrollbar,
       so these controls drive it; touch keeps the native swipe. */
    (function () {
      var root = cards[0] && cards[0].closest('.cu');
      var grid = root && root.querySelector('.cu__grid');
      if (!grid) return;
      var prevBtn = root.querySelector('[data-cu-prev]');
      var nextBtn = root.querySelector('[data-cu-next]');

      function step() {
        var c = grid.querySelector('.cu-card');
        var gap = parseFloat(getComputedStyle(grid).columnGap || getComputedStyle(grid).gap) || 0;
        return c ? c.getBoundingClientRect().width + gap : grid.clientWidth * 0.8;
      }
      function updateNav() {
        var max = grid.scrollWidth - grid.clientWidth - 2;
        if (prevBtn) prevBtn.disabled = grid.scrollLeft <= 2;
        if (nextBtn) nextBtn.disabled = grid.scrollLeft >= max;
      }
      if (prevBtn) prevBtn.addEventListener('click', function () { grid.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (nextBtn) nextBtn.addEventListener('click', function () { grid.scrollBy({ left: step(), behavior: 'smooth' }); });
      grid.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();

      // click-drag (mouse / pen only — touch keeps native swipe).
      // Drag mode engages ONLY after the pointer travels past a threshold, so a
      // plain click never triggers drag side-effects and always opens the video.
      var down = false, dragging = false, startX = 0, startLeft = 0;
      grid.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        down = true; dragging = false; startX = e.clientX; startLeft = grid.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!dragging && Math.abs(dx) > 10) {
          dragging = true;
          grid.classList.add('is-grabbing');
          grid.style.scrollSnapType = 'none';
        }
        if (dragging) grid.scrollLeft = startLeft - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = false;
        if (dragging) {
          grid.classList.remove('is-grabbing');
          grid.style.scrollSnapType = '';
          updateNav();
          // swallow only the click that trails a real drag, so it doesn't open the lightbox
          var swallow = function (ev) { ev.stopPropagation(); ev.preventDefault(); };
          grid.addEventListener('click', swallow, true);
          setTimeout(function () { grid.removeEventListener('click', swallow, true); }, 80);
        }
        dragging = false;
      });
    })();

    /* ── Lightbox controller ──
       Clicking a card opens a big player (fullscreen on mobile, large window on
       desktop) with sound + a CTA panel linking to the product page. */
    var lb = document.querySelector('[data-cu-lightbox]');
    var lbVideo = lb && lb.querySelector('[data-cu-lb-video]');
    var lbHandle = lb && lb.querySelector('[data-cu-lb-handle]');
    var lbQuote = lb && lb.querySelector('[data-cu-lb-quote]');
    var lbAvatar = lb && lb.querySelector('[data-cu-lb-avatar]');
    var canModal = lb && typeof lb.showModal === 'function';

    function pauseAllGrid() {
      items.forEach(function (o) { o.video.pause(); o.video.muted = true; o.card.classList.add('is-muted'); });
    }
    function resumeGrid() {
      if (reduce) return;
      items.forEach(function (o) {
        var r = o.card.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0 && !o.card.classList.contains('cu-user-paused')) {
          var p = o.video.play(); if (p && p.catch) p.catch(function () {});
        }
      });
    }

    function openLightbox(card) {
      if (!canModal || !lbVideo) return;
      var srcVideo = card.querySelector('.cu-card__video');
      if (!srcVideo) return;

      // Rebuild the player sources from the clicked card's <video>.
      lbVideo.pause();
      while (lbVideo.firstChild) lbVideo.removeChild(lbVideo.firstChild);
      lbVideo.removeAttribute('src');
      var srcs = srcVideo.querySelectorAll('source');
      if (srcs.length) {
        srcs.forEach(function (s) {
          var ns = document.createElement('source');
          ns.src = s.src || s.getAttribute('src');
          if (s.type) ns.type = s.type;
          lbVideo.appendChild(ns);
        });
      } else if (srcVideo.currentSrc || srcVideo.src) {
        lbVideo.src = srcVideo.currentSrc || srcVideo.src;
      }
      var poster = srcVideo.getAttribute('poster');
      if (poster) { lbVideo.poster = poster; } else { lbVideo.removeAttribute('poster'); }

      // Populate the CTA panel from the card.
      if (lbHandle) { var h = card.querySelector('.cu-card__handle'); lbHandle.textContent = h ? h.textContent.trim() : ''; }
      if (lbQuote) { var q = card.querySelector('.cu-card__qtext'); lbQuote.textContent = q ? q.textContent.replace(/[“”"]/g, '').trim() : ''; }
      if (lbAvatar) { var a = card.querySelector('.cu-card__avatar'); lbAvatar.innerHTML = a ? a.innerHTML : ''; }

      pauseAllGrid();
      document.documentElement.classList.add('cu-lb-locked');
      lb.showModal();
      lbVideo.load();
      lbVideo.muted = false;
      var pp = lbVideo.play(); if (pp && pp.catch) pp.catch(function () {});
    }

    function closeLightbox() { if (lb && lb.open) { lbVideo.pause(); lb.close(); } }

    if (lb) {
      lb.addEventListener('click', function (e) {
        if (e.target.closest('[data-cu-lb-close]')) { closeLightbox(); return; }
        // Click on the dimmed stage padding (not the player/panel) closes.
        if (e.target === lb || e.target.classList.contains('cu-lb__stage')) closeLightbox();
      });
      lb.addEventListener('close', function () {
        lbVideo.pause();
        while (lbVideo.firstChild) lbVideo.removeChild(lbVideo.firstChild);
        lbVideo.removeAttribute('src');
        document.documentElement.classList.remove('cu-lb-locked');
        resumeGrid();
      });
    }

    cards.forEach(function (card) {
      var video = card.querySelector('.cu-card__video');
      if (!video) return;
      video.muted = true;

      var soundBtn = card.querySelector('[data-cu-sound]');
      items.push({ card: card, video: video, soundBtn: soundBtn });

      // sound is only "locked" on when the user clicks the sound button,
      // so leaving a card with the mouse won't silence a deliberate choice.
      var soundLocked = false;

      // Give sound to this clip only — every other clip goes muted.
      function soloUnmute() {
        items.forEach(function (o) { if (o.video !== video) { o.video.muted = true; } });
        video.muted = false;
        items.forEach(function (o) {
          o.card.classList.toggle('is-muted', o.video.muted);
          if (o.soundBtn) o.soundBtn.setAttribute('aria-pressed', o.video.muted ? 'false' : 'true');
        });
      }
      function ensurePlay() {
        card.classList.remove('cu-user-paused');
        if (video.paused) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        }
      }

      function sync() {
        card.classList.toggle('is-playing', !video.paused);
        card.classList.toggle('is-paused', video.paused);
        card.classList.toggle('is-muted', video.muted);
        if (soundBtn) soundBtn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
      }
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('volumechange', sync);

      // Click the video (anywhere except the sound toggle) → open the lightbox.
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-cu-sound]')) return;
        openLightbox(card);
      });

      if (soundBtn) {
        soundBtn.addEventListener('click', function () {
          if (video.muted) {
            soundLocked = true;
            soloUnmute();
            ensurePlay();
          } else {
            soundLocked = false;
            video.muted = true;
          }
        });
      }

      // Desktop: hovering a clip plays it with sound (muting the others).
      // Leaving re-mutes — unless the sound was locked on via the button.
      if (canHover && !reduce) {
        card.addEventListener('mouseenter', function () {
          soloUnmute();
          ensurePlay();
        });
        card.addEventListener('mouseleave', function () {
          if (!soundLocked) { video.muted = true; }
        });
      }

      sync();
    });

    if (reduce) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (obs) {
        obs.forEach(function (o) {
          var video = o.target.querySelector('.cu-card__video');
          if (!video) return;
          if (o.isIntersecting && o.intersectionRatio >= 0.5) {
            if (!o.target.classList.contains('cu-user-paused')) {
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            }
          } else {
            video.pause();
          }
        });
      }, { threshold: [0, 0.5, 1] });
      cards.forEach(function (c) { io.observe(c); });
    } else {
      items.forEach(function (o) {
        var p = o.video.play();
        if (p && p.catch) p.catch(function () {});
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-consent"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.getElementById('MagicCleanCookies');
    if (!el) return;

    var CHOICE_KEY = 'mc_cc_choice';
    var designMode = window.Shopify && window.Shopify.designMode;
    var privacyApi = null;
    var hideTimer = null;

    function choiceMade() { try { return localStorage.getItem(CHOICE_KEY) === '1'; } catch (e) { return false; } }
    function markChoice() { try { localStorage.setItem(CHOICE_KEY, '1'); } catch (e) {} }

    function setView(view) { el.setAttribute('data-view', view); }

    function show(view) {
      if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
      setView(view || 'main');
      el.hidden = false;
      // next frame so the transition runs from the hidden state
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-open'); }); });
    }
    function hide() {
      el.classList.remove('is-open');
      hideTimer = setTimeout(function () { el.hidden = true; }, 420);
    }

    // ── Shopify Customer Privacy API ──────────────────────────────────────
    function whenPrivacyReady(cb) {
      if (window.Shopify && window.Shopify.customerPrivacy) { cb(window.Shopify.customerPrivacy); return; }
      if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          cb((!err && window.Shopify.customerPrivacy) ? window.Shopify.customerPrivacy : null);
        });
        return;
      }
      // Shopify object not ready yet — poll briefly, then give up gracefully.
      var tries = 0;
      var t = setInterval(function () {
        tries++;
        if (window.Shopify && (window.Shopify.customerPrivacy || window.Shopify.loadFeatures)) {
          clearInterval(t); whenPrivacyReady(cb);
        } else if (tries > 40) { clearInterval(t); cb(null); }
      }, 150);
    }

    function applyConsent(consent, done) {
      markChoice();
      if (privacyApi && typeof privacyApi.setTrackingConsent === 'function') {
        try { privacyApi.setTrackingConsent(consent, function () { if (done) done(); }); return; }
        catch (e) {}
      }
      if (done) done();
    }

    function acceptAll() { applyConsent({ marketing: true, analytics: true, preferences: true, sale_of_data: true }, hide); }
    function rejectAll() { applyConsent({ marketing: false, analytics: false, preferences: false, sale_of_data: false }, hide); }
    function saveChoice() {
      var get = function (name) {
        var input = el.querySelector('[data-cc-toggle="' + name + '"]');
        return !!(input && input.checked);
      };
      var marketing = get('marketing');
      applyConsent({
        analytics: get('analytics'),
        marketing: marketing,
        preferences: get('preferences'),
        sale_of_data: marketing
      }, hide);
    }

    // Prefill the preference toggles from any consent already on file.
    function prefillToggles() {
      if (!privacyApi) return;
      var read = function (fn) { try { return typeof privacyApi[fn] === 'function' ? privacyApi[fn]() : false; } catch (e) { return false; } };
      var map = {
        analytics: read('analyticsProcessingAllowed'),
        marketing: read('marketingAllowed'),
        preferences: read('preferencesProcessingAllowed')
      };
      Object.keys(map).forEach(function (name) {
        var input = el.querySelector('[data-cc-toggle="' + name + '"]');
        if (input) input.checked = !!map[name];
      });
    }

    // ── Wiring ────────────────────────────────────────────────────────────
    el.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cc]');
      if (!btn) return;
      switch (btn.getAttribute('data-cc')) {
        case 'all': acceptAll(); break;
        case 'none': rejectAll(); break;
        case 'prefs': prefillToggles(); setView('prefs'); break;
        case 'back': setView('main'); break;
        case 'save': saveChoice(); break;
      }
    });

    // Public API + footer-link hooks (e.g. a "Gérer les cookies" link)
    window.MagicCleanCookies = {
      open: function () { show('main'); },
      openPreferences: function () { prefillToggles(); show('prefs'); },
      close: hide
    };
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cookie-open], [data-cookie-preferences]');
      if (!t) return;
      e.preventDefault();
      if (t.matches('[data-cookie-preferences]')) window.MagicCleanCookies.openPreferences();
      else window.MagicCleanCookies.open();
    });

    // Theme editor: reveal when the merchant selects the section.
    if (designMode) {
      document.addEventListener('shopify:section:select', function (ev) {
        if (ev.target && ev.target.contains(el)) show('main');
      });
      document.addEventListener('shopify:section:deselect', function (ev) {
        if (ev.target && ev.target.contains(el)) hide();
      });
      return;
    }

    // First-visit decision.
    whenPrivacyReady(function (api) {
      privacyApi = api;
      var forceEverywhere = el.getAttribute('data-display') === 'always';
      if (forceEverywhere) {
        if (!choiceMade()) show('main');
        return;
      }
      // Regulated-regions mode: trust Shopify on whether a banner is required,
      // BUT never re-show once this visitor has already made a choice (the local
      // flag is the source of truth for "already answered"). This prevents the
      // banner from reappearing on every page if shouldShowBanner() stays true.
      if (choiceMade()) return;
      var shouldShow = false;
      if (api && typeof api.shouldShowBanner === 'function') {
        try { shouldShow = api.shouldShowBanner(); } catch (e) { shouldShow = false; }
      }
      if (shouldShow) show('main');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('[data-section-type="faq-accordion"]');
  sections.forEach(function (section) {
    var items = section.querySelectorAll('.faqs-section__item');
    items.forEach(function (item) {
      var btn = item.querySelector('[data-faq-toggle]');
      var collapse = item.querySelector('[data-faq-collapse]');
      if (!btn || !collapse) return;

      function setHeight() {
        var inner = collapse.querySelector('.faqs-section__body');
        if (inner) {
          collapse.style.setProperty('--faq-height', inner.offsetHeight + 'px');
        }
      }

      btn.addEventListener('click', function () {
        var isOpen = collapse.classList.contains('is-open');

        if (isOpen) {
          // close
          setHeight();
          // force reflow with current height set, then animate to 0
          requestAnimationFrame(function () {
            collapse.style.height = collapse.offsetHeight + 'px';
            requestAnimationFrame(function () {
              collapse.classList.remove('is-open');
              btn.classList.add('is-collapsed');
              btn.setAttribute('aria-expanded', 'false');
              collapse.setAttribute('aria-hidden', 'true');
              collapse.style.height = '0px';
            });
          });
        } else {
          // open
          setHeight();
          collapse.classList.add('is-open');
          btn.classList.remove('is-collapsed');
          btn.setAttribute('aria-expanded', 'true');
          collapse.setAttribute('aria-hidden', 'false');
          collapse.style.height = collapse.style.getPropertyValue('--faq-height');
        }
      });

      // Remove inline height after animation completes so content reflows naturally
      collapse.addEventListener('transitionend', function (e) {
        if (e.propertyName !== 'height') return;
        if (collapse.classList.contains('is-open')) {
          collapse.style.height = 'auto';
        }
      });

      // Re-measure on resize so opened panels stay correct
      window.addEventListener('resize', function () {
        if (collapse.classList.contains('is-open')) {
          collapse.style.height = 'auto';
          setHeight();
          collapse.style.height = collapse.style.getPropertyValue('--faq-height');
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-magic"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.fq__q');
    if (!btn) return;
    var item = btn.closest('.fq__item');
    var list = item.closest('.fq__list');
    var willOpen = !item.classList.contains('is-open');
    list.querySelectorAll('.fq__item').forEach(function (i) {
      i.classList.remove('is-open');
      var b = i.querySelector('.fq__q');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
    if (willOpen) {
      item.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["features-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-section-type="features-banner"]').forEach(function (section) {
      // Feature nav (panel 1): click/hover swaps the description
      var navItems = section.querySelectorAll('.fbn__nav-item');
      var panels = section.querySelectorAll('.fbn__tab-content');
      function activate(i) {
        navItems.forEach(function (el, j) { el.classList.toggle('is-active', j === i); el.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
        panels.forEach(function (el, j) { el.classList.toggle('is-current', j === i); });
      }
      navItems.forEach(function (item, i) {
        item.addEventListener('click', function () { activate(i); });
        item.addEventListener('mouseenter', function () { activate(i); });
        item.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(i); } });
      });

      // Animated counters (run once)
      var statsRan = false;
      function runStats() {
        if (statsRan) return; statsRan = true;
        section.querySelectorAll('[data-stat-counter]').forEach(function (el) {
          var p = el.closest('[data-stat-target]'); if (!p) return;
          var target = parseInt(p.getAttribute('data-stat-target'), 10) || 0;
          var dur = 1400, start = performance.now();
          function step(now) {
            var t = Math.min(1, (now - start) / dur);
            var eased = 1 - Math.pow(1 - t, 3);
            el.textContent = Math.round(target * eased).toLocaleString('fr-FR');
            if (t < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      }

      // Segmented switcher + scroll-driven swap
      var switchBtns = section.querySelectorAll('.fbn__switch-btn');
      function setTab(toFormule) {
        section.classList.toggle('is-tab-2', toFormule);
        switchBtns.forEach(function (b, i) { var on = (i === 1) === toFormule; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
        if (toFormule) runStats();
      }
      switchBtns.forEach(function (b) { b.addEventListener('click', function () { setTab(b.getAttribute('data-tab') === '1'); }); });

      var mq = window.matchMedia('(min-width: 900px)');
      function onScroll() {
        if (!mq.matches) return;
        var rect = section.getBoundingClientRect();
        var total = rect.height - window.innerHeight;
        if (total <= 0) return;
        var prog = Math.min(1, Math.max(0, -rect.top / total));
        setTab(prog > 0.5);
      }
      var ticking = false;
      window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(function () { onScroll(); ticking = false; }); ticking = true; } }, { passive: true });
      onScroll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["features-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var THRESHOLDS_DESKTOP = [0.05, 0.125, 0.2, 0.275, 0.35, 0.425];
    var THRESHOLDS_MOBILE = [0.05, 0.135, 0.22, 0.305, 0.39, 0.475];
    var FORMULA_AT_DESKTOP = 0.5;
    var FORMULA_AT_MOBILE = 0.6;
    var ORBS_AT_DESKTOP = 0.56;
    var ORBS_AT_MOBILE = 0.68;

    function clamp01(v) { return Math.max(0, Math.min(1, v)); }

    function countUp(el, target) {
      var start = null;
      var dur = 1100;
      function tick(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(eased * target);
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    function arm(section) {
      if (section.dataset.fs2Bound === '1') return;
      section.dataset.fs2Bound = '1';

      var runway = section.querySelector('[data-fs2-scroll]');
      var benefits = [].slice.call(section.querySelectorAll('[data-fs2-benefit]'));
      var formula = section.querySelector('[data-fs2-formula]');
      var orbs = section.querySelector('[data-fs2-orbs]');
      var tilt = section.querySelector('[data-fs2-tilt]');
      var burstL = section.querySelector('[data-fs2-burst-l]');
      var burstR = section.querySelector('[data-fs2-burst-r]');
      var statEls = [].slice.call(section.querySelectorAll('[data-stat-target]'));
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var mobile = window.matchMedia('(max-width: 880px)');
      var counted = false;
      var lastIdx = -1;
      var formulaShown = false;
      var tiltTimer = null;

      function fireCounters() {
        if (counted) return;
        counted = true;
        statEls.forEach(function (stat) {
          var counter = stat.querySelector('[data-stat-counter]');
          var target = parseInt(stat.dataset.statTarget, 10) || 0;
          if (!counter) return;
          if (reduced) { counter.textContent = target; return; }
          countUp(counter, target);
        });
      }

      if (reduced || !runway) {
        section.classList.add('is-in');
        benefits.forEach(function (b) { b.classList.add('is-on'); });
        if (formula) formula.classList.add('is-on');
        if (orbs) orbs.classList.add('is-on');
        fireCounters();
        return;
      }

      /* .is-in unpauses the ambient bubbles and drives the mobile reveal */
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            section.classList.add('is-in');
          });
        }, { threshold: 0.2 });
        io.observe(section);
      } else {
        section.classList.add('is-in');
      }

      function pop(el) {
        if (!el) return;
        el.classList.remove('is-pop');
        void el.offsetWidth;
        el.classList.add('is-pop');
      }
      /* `both` → symmetric puff (mobile, bottle above the grid); otherwise a
         single side puff (desktop, spraying toward the benefit column). */
      function burst(side, both) {
        if (both) { pop(burstL); pop(burstR); }
        else { pop(side === 'l' ? burstL : burstR); }
        if (tilt) {
          tilt.style.setProperty('--tilt', side === 'l' ? '-7deg' : '7deg');
          clearTimeout(tiltTimer);
          tiltTimer = setTimeout(function () { tilt.style.setProperty('--tilt', '0deg'); }, 720);
        }
      }

      var ticking = false;
      function update() {
        ticking = false;
        var m = mobile.matches;
        var thresholds = m ? THRESHOLDS_MOBILE : THRESHOLDS_DESKTOP;
        var formulaAt = m ? FORMULA_AT_MOBILE : FORMULA_AT_DESKTOP;
        var orbsAt = m ? ORBS_AT_MOBILE : ORBS_AT_DESKTOP;

        var r = runway.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        if (total <= 0) total = 1;
        var p = clamp01(-r.top / total);

        var idx = -1;
        for (var i = 0; i < benefits.length && i < thresholds.length; i++) {
          if (p >= thresholds[i]) idx = i;
        }
        benefits.forEach(function (b, j) { b.classList.toggle('is-on', j <= idx); });
        if (idx > lastIdx) burst(idx % 2 === 0 ? 'l' : 'r', m);
        lastIdx = idx;

        var showFormula = p >= formulaAt;
        if (formula) formula.classList.toggle('is-on', showFormula);
        if (orbs) orbs.classList.toggle('is-on', p >= orbsAt);
        if (showFormula) {
          fireCounters();
          if (!formulaShown) { formulaShown = true; burst('l', true); }
        } else {
          formulaShown = false;
        }
      }
      function onScroll() {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    }

    function boot() { document.querySelectorAll('[data-section-type="features-showcase"]').forEach(arm); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else { boot(); }
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('[data-section-type="features-showcase"]');
      if (s) arm(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-section-type="header"]').forEach(function (header) {
      // ── Mobile drawer ──────────────────────────────────────
      var burger = header.querySelector('.header__burger');
      var drawer = header.querySelector('.header__drawer');
      if (burger && drawer) {
        var closeBtn = drawer.querySelector('[data-close-drawer]');
        function open() {
          if (typeof drawer.showModal === 'function') drawer.showModal();
          else drawer.setAttribute('open', '');
          burger.setAttribute('aria-expanded', 'true');
        }
        function close() {
          if (typeof drawer.close === 'function') drawer.close();
          else drawer.removeAttribute('open');
          burger.setAttribute('aria-expanded', 'false');
        }
        burger.addEventListener('click', open);
        if (closeBtn) closeBtn.addEventListener('click', close);
        drawer.addEventListener('cancel', function () { burger.setAttribute('aria-expanded', 'false'); });
        drawer.addEventListener('close', function () { burger.setAttribute('aria-expanded', 'false'); });
        drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
      }

      // ── Wordmark morphing on scroll ────────────────────────
      // When window.scrollY > 50: add .is-scrolled on .header
      // CSS rules collapse the wordmark from giant fixed bottom-of-nav to
      // a small inline brand mark centered in the nav row, and hide promo bar.
      var ticking = false;
      var lastY = window.scrollY;
      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var wordmark = header.querySelector('.header__wordmark');
      function updateScrollState() {
        var y = window.scrollY;
        header.classList.toggle('is-scrolled', y > 50);
        // Smart sticky (Rhode-style): integrated/transparent at the very top,
        // hide on scroll down, reveal as a floating bar on scroll up.
        if (y < 80) {
          header.classList.remove('header--hidden', 'header--stuck');
        } else if (y > lastY + 4) {
          header.classList.add('header--hidden');
          header.classList.remove('header--stuck');
        } else if (y < lastY - 4) {
          header.classList.remove('header--hidden');
          header.classList.add('header--stuck');
        }
        lastY = y;
        // Giant hero logo: parallax-anchored compress (desktop only). Strong
        // parallax (~0.82) almost cancels the scroll so the logo stays in the
        // upper hero and visibly SHRINKS + DISSOLVES in place — glued to the
        // hero. It fades out FAST (~100px) so the small nav wordmark (which
        // fades in on .is-scrolled) takes over promptly with no empty gap.
        var range = 180;
        var p = Math.min(Math.max(y / range, 0), 1);
        if (wordmark && window.innerWidth >= 1024) {
          if (prefersReduced) {
            wordmark.style.transform = 'translateX(-50%)';
            wordmark.style.opacity = '';
          } else {
            var yc = Math.min(y, range);
            var scale = (1 - 0.5 * p).toFixed(3);
            var parallax = (yc * 0.82).toFixed(1); // holds it roughly in place
            wordmark.style.transform = 'translateX(-50%) translateY(' + parallax + 'px) scale(' + scale + ')';
            wordmark.style.opacity = Math.max(0, 1 - 1.8 * p).toFixed(3);
          }
        }
        ticking = false;
      }
      window.addEventListener('scroll', function () {
        if (!ticking) {
          requestAnimationFrame(updateScrollState);
          ticking = true;
        }
      }, { passive: true });
      // Fire once on init to handle reload at scrollY > 0
      updateScrollState();
    });

    // ── "Nos packs" smart anchor ───────────────────────────
    // On the PDP the hero is side-by-side ≥1000px (image + "Choisissez votre
    // pack") but stacked below it, so desktop points at the hero top and mobile
    // at the pack-selection (cards + add-to-cart). Swap the href on that
    // breakpoint; the home/elsewhere variants are baked into the data-* attrs.
    var packsLinks = document.querySelectorAll('[data-packs-nav]');
    if (packsLinks.length) {
      var packsMq = window.matchMedia('(min-width: 1000px)');
      var syncPacks = function () {
        packsLinks.forEach(function (a) {
          var target = packsMq.matches ? a.getAttribute('data-packs-desktop') : a.getAttribute('data-packs-mobile');
          if (target) a.setAttribute('href', target);
        });
      };
      syncPacks();
      if (packsMq.addEventListener) packsMq.addEventListener('change', syncPacks);
      else if (packsMq.addListener) packsMq.addListener(syncPacks);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var hero = document.querySelector('[data-section-type="hero-v2"]');
    if (!hero) return;
    var canvas = hero.querySelector('.mc-hero__canvas');
    if (!canvas) return;
    var ELS = ['eyebrow', 'title', 'lead', 'ctas', 'rating', 'scene', 'bubble', 'usps'];
    var LBL = { eyebrow: 'Sur-titre', title: 'Titre', lead: 'Paragraphe', ctas: 'Boutons', rating: 'Note', scene: 'Image', bubble: 'Bulle', usps: 'Ligne atouts' };
    var VARS = ['--mc-title', '--mc-title-lh', '--mc-lead', '--mc-accent', '--mc-bg', '--mc-wave', '--mc-canvas-h'];
    var el = {};
    ELS.forEach(function (k) { el[k] = canvas.querySelector('[data-el="' + k + '"]'); });

    function parseL(str) { var m = {}; (str || '').split('|').forEach(function (p) { var c = p.split(':'); if (c.length < 2) return; var n = c[1].split(',').map(Number); m[c[0].trim()] = { x: n[0], y: n[1], w: n[2], z: n[3] }; }); return m; }
    function applyL(m) { Object.keys(m).forEach(function (k) { var e = el[k], g = m[k]; if (!e || !g) return; if (isFinite(g.x)) e.style.left = g.x + '%'; if (isFinite(g.y)) e.style.top = g.y + '%'; if (isFinite(g.w)) e.style.width = g.w + '%'; if (isFinite(g.z)) e.style.zIndex = g.z; }); }

    /* 1) Apply the saved (permanent) layout everywhere, incl. production */
    var savedStr = hero.getAttribute('data-canvas-layout') || '';
    if (savedStr) applyL(parseL(savedStr));

    /* 2) Visual editor — DÉSACTIVÉ (Sacha veut une vue propre pour visualiser les sections).
       La disposition sauvegardée ci-dessus s'applique toujours (prod ET local) ; seuls les
       outils d'édition sont retirés : panneau « Canvas hero · local », poignée « ↕ hauteur »,
       ronds orange de redimensionnement et contours en pointillés.
       👉 Pour réactiver l'éditeur, supprime simplement le `return;` ci-dessous. */
    return;

    var host = location.hostname;
    var isLocal = host === 'localhost' || host === '127.0.0.1' || host === '0.0.0.0' || /\.local$/.test(host);
    if (!isLocal || (window.Shopify && window.Shopify.designMode)) return;
    if (window.innerWidth < 1000) return;

    var DKEY = 'mcHeroCanvas:' + (hero.getAttribute('data-section-id') || 'x');
    try { var raw = localStorage.getItem(DKEY); if (raw) { var dd; try { dd = JSON.parse(raw); } catch (e2) { dd = null; } if (dd && typeof dd === 'object') { if (dd.L) applyL(parseL(dd.L)); if (dd.V) Object.keys(dd.V).forEach(function (n) { if (dd.V[n]) hero.style.setProperty(n, dd.V[n]); }); } else { applyL(parseL(raw)); } } } catch (e) {}

    hero.setAttribute('data-he-live', '');
    function r1(n) { return Math.round(n * 10) / 10; }
    function clamp(n, a, b) { return Math.max(a, Math.min(b, n)); }
    function geom(k) { var e = el[k]; var cr = canvas.getBoundingClientRect(), r = e.getBoundingClientRect(); return { x: r1((r.left - cr.left) / cr.width * 100), y: r1((r.top - cr.top) / cr.height * 100), w: r1(r.width / cr.width * 100), z: parseInt(getComputedStyle(e).zIndex) || 1 }; }
    function serialize() { return ELS.filter(function (k) { return el[k]; }).map(function (k) { var g = geom(k); return k + ':' + g.x + ',' + g.y + ',' + g.w + ',' + g.z; }).join('|'); }
    function saveDraft() { try { var V = {}; VARS.forEach(function (n) { V[n] = getComputedStyle(hero).getPropertyValue(n).trim(); }); localStorage.setItem(DKEY, JSON.stringify({ L: serialize(), V: V })); } catch (e) {} }

    var selected = null;
    function select(k) { selected = k; ELS.forEach(function (x) { if (el[x]) el[x].classList.toggle('mc-he-sel', x === k); }); updSel(); }
    function deselect() { selected = null; ELS.forEach(function (x) { if (el[x]) el[x].classList.remove('mc-he-sel'); }); updSel(); }

    ELS.forEach(function (k) {
      var e = el[k]; if (!e) return;
      e.style.touchAction = 'none';
      e.addEventListener('pointerdown', function (ev) {
        if (ev.target.classList.contains('mc-he-rz')) return;
        ev.preventDefault(); ev.stopPropagation(); select(k);
        var cr = canvas.getBoundingClientRect(), r = e.getBoundingClientRect();
        var ox = ev.clientX - r.left, oy = ev.clientY - r.top;
        e.classList.add('mc-he-moving');
        try { e.setPointerCapture(ev.pointerId); } catch (err) {}
        function mv(m) { e.style.left = clamp((m.clientX - cr.left - ox) / cr.width * 100, -8, 99) + '%'; e.style.top = clamp((m.clientY - cr.top - oy) / cr.height * 100, -8, 99) + '%'; updSel(); }
        function up() { e.classList.remove('mc-he-moving'); e.removeEventListener('pointermove', mv); e.removeEventListener('pointerup', up); saveDraft(); }
        e.addEventListener('pointermove', mv); e.addEventListener('pointerup', up);
      });
      var rz = document.createElement('span'); rz.className = 'mc-he-rz'; e.appendChild(rz);
      rz.addEventListener('pointerdown', function (ev) {
        ev.preventDefault(); ev.stopPropagation(); select(k);
        var cr = canvas.getBoundingClientRect(), sx = ev.clientX, w0 = e.getBoundingClientRect().width;
        try { rz.setPointerCapture(ev.pointerId); } catch (err) {}
        function mv(m) { e.style.width = clamp((w0 + (m.clientX - sx)) / cr.width * 100, 4, 100) + '%'; updSel(); }
        function up() { rz.removeEventListener('pointermove', mv); rz.removeEventListener('pointerup', up); saveDraft(); }
        rz.addEventListener('pointermove', mv); rz.addEventListener('pointerup', up);
      });
    });
    canvas.addEventListener('pointerdown', function (ev) { if (ev.target === canvas) deselect(); });

    /* Panel */
    var panel = document.createElement('div'); panel.className = 'mc-he';
    panel.innerHTML =
      '<div class="mc-he__head"><span class="mc-he__title"><span class="mc-he__dot"></span> Canvas hero · local</span><button class="mc-he__min" type="button">–</button></div>' +
      '<div class="mc-he__body">' +
      '<p class="mc-he__hint">Clique un élément, glisse-le où tu veux, tire le rond orange pour la taille. Tout se superpose librement.</p>' +
      '<div class="mc-he__sel" id="mc-he-sel"></div>' +
      '<div class="mc-he__grp">Titre &amp; texte</div>' +
      '<div class="mc-he__row" data-k="title_size"><div class="mc-he__lab"><span>Taille du titre</span><span class="mc-he__val"></span></div><input type="range" min="28" max="160" step="2"></div>' +
      '<div class="mc-he__row" data-k="title_line_height"><div class="mc-he__lab"><span>Interligne titre</span><span class="mc-he__val"></span></div><input type="range" min="80" max="130" step="1"></div>' +
      '<div class="mc-he__row" data-k="lead_size"><div class="mc-he__lab"><span>Taille paragraphe</span><span class="mc-he__val"></span></div><input type="range" min="13" max="26" step="1"></div>' +
      '<div class="mc-he__grp">Mise en page</div>' +
      '<div class="mc-he__row" data-k="canvas_height"><div class="mc-he__lab"><span>Hauteur de la section</span><span class="mc-he__val"></span></div><input type="range" min="380" max="1000" step="10"></div>' +
      '<div class="mc-he__grp">Couleurs</div>' +
      '<div class="mc-he__row mc-he__color" data-c="accent_color"><span>Accent titre</span><input type="color"></div>' +
      '<div class="mc-he__row mc-he__color" data-c="bg_color"><span>Fond</span><input type="color"></div>' +
      '<div class="mc-he__row mc-he__color" data-c="wave_color"><span>Vague</span><input type="color"></div>' +
      '</div>' +
      '<div class="mc-he__foot"><button type="button" class="mc-he__apply">✓ Valider</button><button type="button" class="mc-he__reset">Réinitialiser</button></div>';
    document.body.appendChild(panel);

    /* Only show the panel while the hero is on screen, so it never covers
       content from the sections below (benefits, formula strip, etc.). */
    if ('IntersectionObserver' in window) {
      panel.style.display = 'none';
      new IntersectionObserver(function (entries) {
        panel.style.display = entries[0].isIntersecting ? '' : 'none';
      }, { threshold: 0.05 }).observe(hero);
    }

    var selBox = panel.querySelector('#mc-he-sel');
    function updSel() {
      if (!selected || !el[selected]) { selBox.innerHTML = '<span style="opacity:.55">Clique un élément pour le régler…</span>'; return; }
      var g = geom(selected);
      selBox.innerHTML = '<div class="mc-he__selname">' + (LBL[selected] || selected) + '</div>' +
        '<div class="mc-he__xy">' +
        '<label>X %<input type="number" data-g="x" value="' + g.x + '"></label>' +
        '<label>Y %<input type="number" data-g="y" value="' + g.y + '"></label>' +
        '<label>Largeur %<input type="number" data-g="w" value="' + g.w + '"></label>' +
        '</div>' +
        '<div class="mc-he__layer"><button type="button" data-l="front">▲ Devant</button><button type="button" data-l="back">▼ Derrière</button></div>';
      selBox.querySelectorAll('input[data-g]').forEach(function (inp) {
        inp.addEventListener('input', function () { var e = el[selected]; var p = inp.getAttribute('data-g'); var v = parseFloat(inp.value) || 0; if (p === 'x') e.style.left = v + '%'; else if (p === 'y') e.style.top = v + '%'; else e.style.width = v + '%'; saveDraft(); });
      });
      selBox.querySelector('[data-l="front"]').addEventListener('click', function () { bumpZ(1); });
      selBox.querySelector('[data-l="back"]').addEventListener('click', function () { bumpZ(-1); });
    }
    function bumpZ(d) { var e = el[selected]; var z = (parseInt(getComputedStyle(e).zIndex) || 1) + d; e.style.zIndex = Math.max(0, z); saveDraft(); }

    /* Global sliders/colors via the same CSS vars used server-side */
    function rv(n) { return getComputedStyle(hero).getPropertyValue(n).trim(); }
    function nv(n) { return parseFloat(rv(n)) || 0; }
    function hx(v) { v = (v || '').trim(); if (v.charAt(0) !== '#') return '#ffffff'; return v.length === 4 ? '#' + v[1] + v[1] + v[2] + v[2] + v[3] + v[3] : v.slice(0, 7); }
    var globals = { title_size: { v: '--mc-title', u: 'px' }, title_line_height: { v: '--mc-title-lh', u: '', mul: 100 }, lead_size: { v: '--mc-lead', u: 'px' }, canvas_height: { v: '--mc-canvas-h', u: 'px' } };
    var gcolors = { accent_color: '--mc-accent', bg_color: '--mc-bg', wave_color: '--mc-wave' };
    var gInputs = {};
    function syncGlobal(k) { var g = gInputs[k]; if (!g) return; var cur = nv(g.cfg.v); if (g.cfg.mul) cur = Math.round(cur * g.cfg.mul); g.inp.value = Math.round(cur); g.out.textContent = Math.round(cur) + (g.cfg.u || (g.cfg.mul ? '%' : '')); }
    Object.keys(globals).forEach(function (k) {
      var cfg = globals[k], row = panel.querySelector('.mc-he__row[data-k="' + k + '"]'), inp = row.querySelector('input'), out = row.querySelector('.mc-he__val');
      gInputs[k] = { inp: inp, out: out, cfg: cfg };
      syncGlobal(k);
      inp.addEventListener('input', function () { var val = parseFloat(inp.value); hero.style.setProperty(cfg.v, (cfg.mul ? val / cfg.mul : val) + (cfg.u === 'px' ? 'px' : '')); out.textContent = val + (cfg.u || (cfg.mul ? '%' : '')); saveDraft(); });
    });
    Object.keys(gcolors).forEach(function (k) {
      var row = panel.querySelector('.mc-he__color[data-c="' + k + '"]'), inp = row.querySelector('input');
      inp.value = hx(rv(gcolors[k]));
      inp.addEventListener('input', function () { hero.style.setProperty(gcolors[k], inp.value); saveDraft(); });
    });

    /* Section-height drag handle at the bottom of the canvas */
    var hbar = document.createElement('div'); hbar.className = 'mc-he-hbar'; hbar.textContent = '↕ hauteur'; canvas.appendChild(hbar);
    hbar.addEventListener('pointerdown', function (ev) {
      ev.preventDefault(); ev.stopPropagation();
      var y0 = ev.clientY, h0 = canvas.getBoundingClientRect().height;
      try { hbar.setPointerCapture(ev.pointerId); } catch (e) {}
      function mv(m) { hero.style.setProperty('--mc-canvas-h', (Math.round(clamp(h0 + (m.clientY - y0), 320, 1200) / 10) * 10) + 'px'); syncGlobal('canvas_height'); }
      function up() { hbar.removeEventListener('pointermove', mv); hbar.removeEventListener('pointerup', up); saveDraft(); }
      hbar.addEventListener('pointermove', mv); hbar.addEventListener('pointerup', up);
    });

    panel.querySelector('.mc-he__min').addEventListener('click', function () { panel.classList.toggle('mc-he--min'); this.textContent = panel.classList.contains('mc-he--min') ? '+' : '–'; });
    panel.querySelector('.mc-he__reset').addEventListener('click', function () { try { localStorage.removeItem(DKEY); } catch (e) {} location.reload(); });
    panel.querySelector('.mc-he__apply').addEventListener('click', function () {
      var out = {
        canvas_layout: serialize(),
        canvas_height: Math.round(nv('--mc-canvas-h') / 10) * 10,
        title_size: Math.round(nv('--mc-title') / 2) * 2,
        title_line_height: Math.round(nv('--mc-title-lh') * 100),
        lead_size: Math.round(nv('--mc-lead')),
        accent_color: hx(rv('--mc-accent')), bg_color: hx(rv('--mc-bg')), wave_color: hx(rv('--mc-wave'))
      };
      var txt = JSON.stringify(out, null, 2);
      saveDraft();
      if (navigator.clipboard) navigator.clipboard.writeText(txt);
      try {
        var blob = new Blob([txt], { type: 'application/json' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a'); a.href = url; a.download = 'magic-clean-hero.json';
        document.body.appendChild(a); a.click();
        setTimeout(function () { document.body.removeChild(a); URL.revokeObjectURL(url); }, 200);
      } catch (e) {}
      var t = document.createElement('div'); t.className = 'mc-he-toast'; t.textContent = '✓ Réglages validés — dis « publie » à Claude pour les mettre en ligne.'; document.body.appendChild(t); setTimeout(function () { t.remove(); }, 3800);
    });

    updSel();
    window.addEventListener('resize', function () { if (selected) updSel(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-section-type="hero"]').forEach(function (section) {
      // prefers-reduced-motion: swap video for static poster
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var video = section.querySelector('.hero__video');
        if (video && video.poster) {
          var img = document.createElement('img');
          img.src = video.poster;
          img.alt = '';
          img.className = video.className;
          img.style.width = '100%';
          img.style.height = '100%';
          img.style.objectFit = 'cover';
          video.replaceWith(img);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-no-compromise"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var BP = '(max-width: 900px)';
    var SETS = 3;            // the track renders three identical sets of reviews
    var SET_SECONDS = 34;    // one set glides past in ~34s (matches the desktop marquee)

    function init(root) {
      if (root.dataset.ncInit) return;
      var viewport = root.querySelector('[data-nc-reviews]');
      var track = root.querySelector('[data-nc-track]');
      if (!viewport || !track) return;
      root.dataset.ncInit = '1';

      var mq = window.matchMedia(BP);
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

      var setW = 0, speed = 0;          // px for one set, px/sec glide speed
      var enabled = false, paused = false;
      var rafId = null, lastTs = 0;
      var resumeTimer = null, settleTimer = null;

      function measure() {
        setW = track.scrollWidth / SETS;
        speed = setW / SET_SECONDS;
      }

      // Keep the scroll position inside the middle set so the user never reaches
      // a real edge — the swapped-in set is identical, so the jump is invisible.
      function normalize() {
        if (!enabled || !setW) return;
        var x = viewport.scrollLeft;
        if (x >= setW * 2) viewport.scrollLeft = x - setW;
        else if (x < setW) viewport.scrollLeft = x + setW;
      }

      function onScroll() {
        if (!enabled) return;
        // While the auto-glide drives the scroll it normalises itself; only fall
        // back to a settle-debounced normalize for user-driven (or reduced-
        // motion) scrolling, so we never cancel an in-flight flick.
        if (!paused && !reduce.matches) return;
        if (settleTimer) clearTimeout(settleTimer);
        settleTimer = setTimeout(normalize, 90);
      }

      function pause() {
        paused = true;
        if (resumeTimer) clearTimeout(resumeTimer);
      }
      function resumeSoon() {
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () { paused = false; lastTs = 0; }, 2600);
      }
      function nudge() { pause(); resumeSoon(); }

      function frame(ts) {
        if (!enabled) return;
        if (!lastTs) lastTs = ts;
        var dt = ts - lastTs;
        lastTs = ts;
        if (dt > 50) dt = 50; // clamp after a background-tab stall
        if (!paused && !reduce.matches) {
          if (!setW) measure();
          viewport.scrollLeft += speed * dt / 1000;
          if (viewport.scrollLeft >= setW * 2) viewport.scrollLeft -= setW;
        }
        rafId = requestAnimationFrame(frame);
      }

      // Listeners are bound once; they no-op until the carousel is enabled.
      viewport.addEventListener('scroll', onScroll, { passive: true });
      viewport.addEventListener('pointerdown', pause, { passive: true });
      viewport.addEventListener('pointerup', resumeSoon, { passive: true });
      viewport.addEventListener('pointercancel', resumeSoon, { passive: true });
      viewport.addEventListener('touchstart', pause, { passive: true });
      viewport.addEventListener('touchend', resumeSoon, { passive: true });
      viewport.addEventListener('wheel', nudge, { passive: true });

      function enable() {
        if (enabled) return;
        enabled = true;
        measure();
        viewport.scrollLeft = setW; // start in the middle set
        lastTs = 0;
        rafId = requestAnimationFrame(frame);
      }
      function disable() {
        if (!enabled) return;
        enabled = false;
        if (rafId) cancelAnimationFrame(rafId);
        rafId = null;
        viewport.scrollLeft = 0; // hand back to the desktop CSS marquee
      }
      // iOS Safari: the JS auto-glide set viewport.scrollLeft from a measured
      // track width that mis-computes on Safari, pushing the cards off-screen
      // ("they appear then vanish"). Disable the JS scroll entirely — mobile is
      // a plain native swipe (duplicates hidden via CSS), desktop keeps the CSS
      // marquee (which is animation-only, not JS-driven).
      function apply() { disable(); }

      apply();
      if (mq.addEventListener) mq.addEventListener('change', apply);
      else if (mq.addListener) mq.addListener(apply);

      var rt;
      window.addEventListener('resize', function () {
        if (rt) clearTimeout(rt);
        rt = setTimeout(function () { if (enabled) { measure(); normalize(); } }, 150);
      }, { passive: true });
    }

    function boot() {
      var list = document.querySelectorAll('[data-section-type="home-no-compromise"]');
      for (var i = 0; i < list.length; i++) init(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    // Theme editor: re-init a freshly loaded section.
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector ? e.target.querySelector('[data-section-type="home-no-compromise"]') : null;
      if (s) init(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function clamp01(v) { return Math.max(0, Math.min(1, v)); }
    function ease(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }

    function arm(section) {
      if (section.dataset.hw2Bound === '1') return;
      section.dataset.hw2Bound = '1';

      var runway = section.querySelector('[data-hw2-scroll]');
      var stained = section.querySelector('[data-tee-stained]');
      var fill = section.querySelector('[data-hw2-fill]');
      var steps = [].slice.call(section.querySelectorAll('[data-hw2-step]'));
      var notes = [].slice.call(section.querySelectorAll('[data-hw2-note]'));
      var progress = section.querySelector('[data-hw2-progress]');
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduced || !runway) {
        if (stained) stained.style.opacity = '0';
        if (fill) fill.style.transform = 'scaleY(1)';
        if (progress) progress.style.transform = 'scaleX(1)';
        steps.forEach(function (s) { s.classList.add('is-active'); s.classList.remove('is-done'); });
        notes.forEach(function (n, i) { n.classList.toggle('is-on', i === notes.length - 1); });
        return;
      }

      var ticking = false;
      function update() {
        ticking = false;
        var r = runway.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        if (total <= 0) total = 1;
        var p = clamp01(-r.top / total);

        /* tee: fully stained while step 1 settles, spotless before step 4 */
        var clean = ease(clamp01((p * 4 - 0.55) / 2.75));
        if (stained) stained.style.opacity = (1 - clean).toFixed(3);
        if (fill) fill.style.transform = 'scaleY(' + p.toFixed(4) + ')';

        var idx = Math.min(steps.length - 1, Math.floor(p * steps.length));
        steps.forEach(function (s, i) {
          s.classList.toggle('is-active', i === idx);
          s.classList.toggle('is-done', i < idx);
        });
        notes.forEach(function (n, i) { n.classList.toggle('is-on', i === idx); });
        if (progress) progress.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      }
      function onScroll() {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    }

    function boot() { document.querySelectorAll('[data-section-type="how-it-works-v2"]').forEach(arm); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else { boot(); }
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('[data-section-type="how-it-works-v2"]');
      if (s) arm(s);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-hub"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-section-type="legal-hub"] .lh-acc__q');
    if (!btn) return;
    var item = btn.closest('.lh-acc__item');
    var willOpen = !item.classList.contains('is-open');
    item.classList.toggle('is-open', willOpen);
    btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
  });

  // Mobile sommaire: tapping the "Sommaire" bar expands/collapses the page list.
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-section-type="legal-hub"] [data-lh-nav-toggle]');
    if (!toggle) return;
    var card = toggle.closest('.lh__side-card');
    if (!card) return;
    var open = card.classList.toggle('is-nav-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magic-vs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.mv');
    if (!sections.length) return;

    /* Count-up for the "1001" in the punchline */
    function countUp(el) {
      var target = parseInt(el.getAttribute('data-count'), 10);
      if (isNaN(target)) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var duration = 1300;
      var start = null;
      function tick(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(eased * target);
        if (p < 1) requestAnimationFrame(tick);
        else el.textContent = target;
      }
      requestAnimationFrame(tick);
    }

    function reveal(section) {
      section.classList.add('is-in');
      var num = section.querySelector('.mv__tag-num');
      if (num) countUp(num);
    }

    if (!('IntersectionObserver' in window)) {
      sections.forEach(reveal);
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { reveal(en.target); io.unobserve(en.target); }
        });
      }, { threshold: 0.18 });
      sections.forEach(function (s) { io.observe(s); });
    }

    /* Row hover — light up every cell of the hovered row across the grid */
    sections.forEach(function (section) {
      var table = section.querySelector('.mv__table');
      if (!table) return;
      var current = null;
      function setRow(row) {
        if (row === current) return;
        if (current !== null) {
          table.querySelectorAll('[data-row="' + current + '"]').forEach(function (c) { c.classList.remove('is-hot'); });
        }
        current = row;
        if (row !== null) {
          table.querySelectorAll('[data-row="' + row + '"]').forEach(function (c) { c.classList.add('is-hot'); });
        }
      }
      table.addEventListener('mouseover', function (e) {
        var cell = e.target.closest('[data-row]');
        setRow(cell ? cell.getAttribute('data-row') : null);
      });
      table.addEventListener('mouseleave', function () { setRow(null); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var dlg = document.getElementById('MagicCleanPopup');
    if (!dlg || typeof dlg.showModal !== 'function') return;

    var KEY = 'mc_np_seen';
    var MODE_KEY = 'mc_np_submit_mode';
    var emailInput = dlg.querySelector('.np__input');
    var tagsInput = dlg.querySelector('[data-np-tags]');
    var baseAria = dlg.getAttribute('aria-label') || '';
    var designMode = window.Shopify && window.Shopify.designMode;

    function markSeen() { try { localStorage.setItem(KEY, '1'); } catch (e) {} }
    function seen() { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } }

    // promo = welcome -10% offer · notify = "Prévenez-moi" (email only, no discount)
    function setMode(mode) {
      dlg.setAttribute('data-mode', mode);
      if (tagsInput) tagsInput.value = (mode === 'notify') ? 'notify, popup' : 'newsletter, popup';
      dlg.setAttribute('aria-label', (mode === 'notify') ? 'Être prévenu par e-mail' : baseAria);
    }

    function openPopup(state, mode) {
      if (dlg.open) return;
      state = state || 'form';
      mode = mode || 'promo';
      setMode(mode);
      dlg.setAttribute('data-state', state);
      // Load the mascot only now (popup is hidden on page load → keeps its ~107KB
      // off the initial load). Visually identical: it appears as the popup opens.
      var npMascot = dlg.querySelector('.np__mascot[data-src]');
      if (npMascot) { npMascot.src = npMascot.getAttribute('data-src'); npMascot.removeAttribute('data-src'); }
      dlg.showModal();
      // Only the welcome offer consumes the "already seen" flag — opening the
      // notify popup must not suppress the site-wide welcome popup elsewhere.
      if (mode === 'promo') markSeen();
      if (state !== 'success' && emailInput) {
        setTimeout(function () { try { emailInput.focus(); } catch (e) {} }, 80);
      }
    }
    function closePopup() { if (dlg.open) dlg.close(); }
    window.MagicCleanPopup = {
      open: function () { openPopup('form', 'promo'); },
      notify: function () { openPopup('form', 'notify'); },
      close: closePopup
    };

    // Close ONLY on a deliberate action: × button, [data-np-close], Escape (native
    // to <dialog>), or a click on the dimmed backdrop. A backdrop click reports the
    // <dialog> element itself as the target; clicks on the card or its children
    // never do — so this is a robust "click-outside" test, no coordinate math.
    var closeBtn = dlg.querySelector('.np__close');
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    dlg.addEventListener('click', function (e) {
      if (e.target.closest('[data-np-close]')) { closePopup(); return; }
      if (e.target === dlg) closePopup();
    });

    // Manual triggers anywhere (e.g. the "Nous suivre" community button opens the
    // promo; the "Prévenez-moi" coming-soon button carries data-np-mode="notify").
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-newsletter-open]');
      if (trigger) { e.preventDefault(); openPopup('form', trigger.getAttribute('data-np-mode') || 'promo'); }
    });

    // Submit the email straight to Klaviyo (client subscriptions endpoint — CORS-enabled,
    // no auth, no page reload, no Shopify captcha). On success we flip to the success state
    // (which reveals the code) and drop the discount cookie so it auto-applies at checkout.
    var formEl = dlg.querySelector('.np__form');
    if (formEl) {
      formEl.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = emailInput && emailInput.value.trim();
        if (!email) return;
        var mode = dlg.getAttribute('data-mode') || 'promo';
        var btn = formEl.querySelector('.np__submit');
        var errEl = formEl.querySelector('.np__error');
        if (errEl) errEl.textContent = '';
        if (btn) btn.disabled = true;
        var company = dlg.getAttribute('data-kl-company');
        var listId = dlg.getAttribute('data-kl-list');
        function ok() {
          if (btn) btn.disabled = false;
          dlg.setAttribute('data-state', 'success');
          if (mode === 'promo') markSeen();
          if (mode !== 'notify') applyDiscount();
        }
        function fail() {
          if (btn) btn.disabled = false;
          if (errEl) errEl.textContent = 'Oups, on n’a pas pu t’inscrire. Vérifie ton e-mail et réessaie.';
        }
        if (!company || !listId) { ok(); return; } // Klaviyo not configured → still honor the offer
        var payload = { data: { type: 'subscription', attributes: {
          custom_source: (mode === 'notify') ? 'Popup — Prévenez-moi' : 'Popup — Bienvenue -10%',
          profile: { data: { type: 'profile', attributes: { email: email } } }
        }, relationships: { list: { data: { type: 'list', id: listId } } } } };
        try {
          fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(company), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
            body: JSON.stringify(payload)
          }).then(function (res) { if (res && res.ok) { ok(); } else { fail(); } }).catch(fail);
        } catch (err) { fail(); }
      });
    }

    // Register the welcome discount so it auto-applies at checkout. Same-origin GET
    // to /discount/CODE drops the discount cookie; the code is also shown for manual
    // entry, so this is a best-effort enhancement — a failure is harmless.
    var discountDone = false;
    function applyDiscount() {
      if (discountDone) return;
      var code = dlg.getAttribute('data-discount');
      if (!code) return;
      discountDone = true;
      try { fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }); } catch (e) {}
    }

    // Copy the discount code
    var copyBtn = dlg.querySelector('.np__copy');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.getAttribute('data-code') || '';
        var done = function () {
          var prev = copyBtn.textContent;
          copyBtn.textContent = 'Copié ✓';
          setTimeout(function () { copyBtn.textContent = prev; }, 1600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else { done(); }
      });
    }

    // Theme editor: open when the merchant selects the section, close on deselect
    if (designMode) {
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target && e.target.contains(dlg)) openPopup('form');
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target && e.target.contains(dlg)) closePopup();
      });
      return; // don't auto-pop over the editor canvas unprompted
    }

    // Auto-open once for new visitors. It never closes on its own afterwards —
    // the visitor dismisses it with ×, Échap, the backdrop or "Continuer".
    if (dlg.getAttribute('data-enabled') === 'true' && !seen()) {
      var delay = parseInt(dlg.getAttribute('data-delay'), 10);
      if (isNaN(delay)) delay = 3000;
      setTimeout(function () { if (!dlg.open && !seen()) openPopup('form'); }, delay);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-section-type="pdp-hero"]').forEach(function (root) {
    /* ── Buy box: pack selection ── */
    var idField = root.querySelector('[data-ph-id]');
    var priceOut = root.querySelector('[data-ph-price]');
    var shipOut = root.querySelector('[data-ph-ship]');
    var freeShip = parseFloat(root.getAttribute('data-free-ship')) || 0;
    // Refined thin-line truck (matches the cart drawer + kit cards), no emoji.
    var TRUCK_SVG = '<svg class="ph__ship-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v9H3z"/><path d="M14 9h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>';

    // Parse a localized price string ("49,99 €") into a number for the free-ship test.
    function priceValue(str) {
      if (!str) return 0;
      return parseFloat(str.replace(/[^0-9.,]/g, '').replace(/\s/g, '').replace(',', '.')) || 0;
    }
    // Pack selector keeps it premium: a quiet free-shipping line — "offerte" once the
    // pack clears the threshold, otherwise a subtle "offerte dès Xe" nudge. The exact
    // cost below the threshold (buyer-location dependent) is resolved in the cart.
    function updateShip(pack) {
      if (!shipOut || !freeShip) return;
      var val = priceValue(pack && pack.getAttribute('data-price'));
      if (val >= freeShip) {
        shipOut.className = 'ph__ship is-free';
        shipOut.innerHTML = TRUCK_SVG + '<span>Livraison offerte</span>';
      } else {
        shipOut.className = 'ph__ship';
        shipOut.innerHTML = TRUCK_SVG + '<span>Livraison offerte dès <strong>' + freeShip + '€</strong></span>';
      }
      shipOut.hidden = false;
    }

    root.querySelectorAll('.ph__pack').forEach(function (pack) {
      pack.addEventListener('click', function () {
        var radio = pack.querySelector('.ph__pack-radio');
        if (!radio || radio.disabled) return;
        radio.checked = true;
        root.querySelectorAll('.ph__pack').forEach(function (p) { p.classList.remove('is-active'); });
        pack.classList.add('is-active');
        if (idField && radio.value) idField.value = radio.value;
        if (priceOut && pack.getAttribute('data-price')) priceOut.textContent = pack.getAttribute('data-price');
        updateShip(pack);
      });
    });

    updateShip(root.querySelector('.ph__pack.is-active') || root.querySelector('.ph__pack'));

    /* ── Gallery: thumbs + arrows + swipe + yellow bars, synced on scroll ── */
    var track = root.querySelector('[data-ph-track]');
    if (!track) return;
    var slides = track.querySelectorAll('.ph__slide');
    var thumbs = root.querySelectorAll('[data-ph-thumb]');
    var prev = root.querySelector('[data-ph-prev]');
    var next = root.querySelector('[data-ph-next]');

    /* Build bar indicators to match slide count */
    var dotsWrap = root.querySelector('[data-ph-dots]');
    var dots = [];
    if (dotsWrap) {
      for (var i = 0; i < slides.length; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'ph__dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('data-dot', i);
        d.setAttribute('aria-label', 'Visuel ' + (i + 1));
        dotsWrap.appendChild(d);
        dots.push(d);
      }
    }

    function current() { return Math.round(track.scrollLeft / track.clientWidth); }
    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-ph-thumb'), 10)); }); });
    dots.forEach(function (d) { d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-dot'), 10)); }); });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var c = current();
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === c); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === c); });
        ticking = false;
      });
    }, { passive: true });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-section-type="packs"]').forEach(function (section) {
      var track = section.querySelector('.packs__grid');
      var dotsWrap = section.querySelector('.packs__dots');
      if (!track || !dotsWrap) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('.kit'));
      if (cards.length < 2 || dotsWrap.children.length) return;

      cards.forEach(function (card, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'packs__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Aller au pack ' + (i + 1));
        dot.addEventListener('click', function () {
          var left = card.offsetLeft - (track.clientWidth - card.clientWidth) / 2;
          track.scrollTo({ left: left, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
      });
      var dots = Array.prototype.slice.call(dotsWrap.children);

      function setActive(i) {
        dots.forEach(function (d, di) {
          d.classList.toggle('is-active', di === i);
          d.setAttribute('aria-selected', di === i ? 'true' : 'false');
        });
      }
      setActive(0);

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting && e.intersectionRatio >= 0.6) {
              var idx = cards.indexOf(e.target);
              if (idx > -1) setActive(idx);
            }
          });
        }, { root: track, threshold: [0.6] });
        cards.forEach(function (c) { io.observe(c); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-info"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CURRENCY = window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'EUR';
    var LOCALE = document.documentElement.lang || 'fr';
    function money(cents) {
      try {
        return new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CURRENCY }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + CURRENCY;
      }
    }

    document.querySelectorAll('[data-section-type="product-info"]').forEach(function (section) {
      /* ── Gallery slider (swipe + arrows + segmented lines) ── */
      var track = section.querySelector('[data-bb-track]');
      var slides = [].slice.call(section.querySelectorAll('[data-bb-slide]'));
      var bars = [].slice.call(section.querySelectorAll('[data-bb-bar]'));
      var prevBtn = section.querySelector('[data-bb-prev]');
      var nextBtn = section.querySelector('[data-bb-next]');
      var current = 0;

      function setActive(i) {
        current = Math.max(0, Math.min(slides.length - 1, i));
        bars.forEach(function (b, idx) { b.classList.toggle('is-active', idx === current); });
      }
      function goTo(i, instant) {
        if (!track || !slides.length) return;
        i = Math.max(0, Math.min(slides.length - 1, i));
        var prevBehavior = track.style.scrollBehavior;
        if (instant) track.style.scrollBehavior = 'auto';
        track.scrollLeft = i * track.clientWidth;
        if (instant) track.style.scrollBehavior = prevBehavior;
        setActive(i);
      }
      bars.forEach(function (b) {
        b.addEventListener('click', function () { goTo(parseInt(b.getAttribute('data-index'), 10) || 0); });
      });
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
      if (track) {
        var raf;
        track.addEventListener('scroll', function () {
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            if (track.clientWidth) setActive(Math.round(track.scrollLeft / track.clientWidth));
          });
        }, { passive: true });
      }

      var idInput = section.querySelector('[data-bb-id]');
      var addBtn = section.querySelector('[data-bb-add]');
      var addPrice = section.querySelector('[data-bb-add-price]');
      var barPrice = section.querySelector('[data-bb-bar-price]');
      var saving = section.querySelector('[data-bb-saving]');
      var subToggle = section.querySelector('[data-bb-sub-toggle]');
      var sub = section.querySelector('[data-bb-sub]');
      var freq = section.querySelector('[data-bb-freq]');

      if (subToggle) {
        subToggle.addEventListener('change', function () {
          if (sub) sub.classList.toggle('is-on', subToggle.checked);
          if (freq) freq.disabled = !subToggle.checked;
        });
      }

      var mode = section.getAttribute('data-mode');

      if (mode === 'variants') {
        var cards = [].slice.call(section.querySelectorAll('[data-bb-pack]'));
        var recap = section.querySelector('[data-bb-recap]');
        if (!cards.length) return;

        function chosen() {
          return cards.find(function (c) { var i = c.querySelector('input'); return i && i.checked; })
            || cards.find(function (c) { return c.getAttribute('data-available') === 'true'; })
            || cards[0];
        }
        function render() {
          var c = chosen();
          var cents = parseInt(c.getAttribute('data-cents'), 10) || 0;
          var compare = parseInt(c.getAttribute('data-compare'), 10) || 0;

          cards.forEach(function (x) { x.classList.toggle('is-current', x === c); });
          if (idInput) idInput.value = c.getAttribute('data-variant-id') || idInput.value;
          var slide = parseInt(c.getAttribute('data-slide'), 10);
          if (!isNaN(slide)) goTo(slide);
          var priceStr = c.getAttribute('data-price') || money(cents);
          if (addPrice) addPrice.textContent = '— ' + priceStr;
          if (barPrice) barPrice.textContent = priceStr;

          if (recap) {
            var fl = parseInt(c.getAttribute('data-flacons'), 10) || 0;
            var off = parseInt(c.getAttribute('data-offerts'), 10) || 0;
            var ml = parseInt(c.getAttribute('data-vol'), 10) || 0;
            var parts = [];
            if (fl > 0) {
              parts.push(fl + ' flacon' + (fl > 1 ? 's' : '') + (off ? ' (dont ' + off + ' offert' + (off > 1 ? 's' : '') + ')' : ''));
            } else {
              parts.push(c.getAttribute('data-title') || '');
            }
            if (ml) parts.push(ml >= 1000 ? (ml / 1000).toFixed(2).replace('.', ',') + ' L' : ml + ' mL');
            if (fl > 0) parts.push(money(Math.round(cents / fl)) + ' le flacon');
            else parts.push(c.getAttribute('data-price') || money(cents));
            recap.textContent = parts.filter(Boolean).join(' · ');
          }
          var saved = compare > cents ? compare - cents : 0;
          if (saving) {
            if (saved > 0) { saving.textContent = 'Vous économisez ' + money(saved); saving.hidden = false; }
            else saving.hidden = true;
          }
        }
        cards.forEach(function (c) { var i = c.querySelector('input'); if (i) i.addEventListener('change', render); });
        render();
      } else {
        /* Single variant — quantity stepper */
        var qty = section.querySelector('[data-bb-qty]');
        var minus = section.querySelector('[data-bb-qty-minus]');
        var plus = section.querySelector('[data-bb-qty-plus]');
        var unitEl = section.querySelector('[data-bb-unit-price]');
        var unitCents = unitEl ? (parseInt(unitEl.getAttribute('data-cents'), 10) || 0) : 0;

        function getQty() { var n = parseInt(qty && qty.value, 10); return (!n || n < 1) ? 1 : n; }
        function render() {
          var n = getQty();
          if (qty) qty.value = n;
          if (addPrice) addPrice.textContent = unitCents ? '— ' + money(unitCents * n) : '';
        }
        if (minus) minus.addEventListener('click', function () { if (qty) qty.value = Math.max(1, getQty() - 1); render(); });
        if (plus) plus.addEventListener('click', function () { if (qty) qty.value = getQty() + 1; render(); });
        if (qty) qty.addEventListener('input', render);
        render();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-section-type="promo-bar"]').forEach(function (root) {
      var track = root.querySelector('.promo-bar__track');
      if (!track) return;
      var items = Array.prototype.slice.call(track.querySelectorAll('.promo-bar__item'));
      if (items.length === 0) return;
      track.setAttribute('data-ready', '');

      var interval = parseInt(root.getAttribute('data-interval'), 10) || 4000;
      var toggle = root.querySelector('[data-promo-toggle]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var current = 0;
      var timer = null;
      var paused = false;

      function show(i) {
        items[current].classList.remove('is-active');
        current = (i + items.length) % items.length;
        items[current].classList.add('is-active');
      }
      function next() { show(current + 1); }
      function start() {
        if (timer || items.length < 2 || paused || reduce) return;
        timer = setInterval(next, interval);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      if (toggle) {
        toggle.addEventListener('click', function () {
          paused = !paused;
          toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
          if (paused) { stop(); } else { start(); }
        });
      }
      // Pause when the tab is hidden, resume when visible (unless user-paused)
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); } else if (!paused) { start(); }
      });

      // Publish the bar height so the fixed header nav can drop just beneath it
      function publishHeight() {
        document.documentElement.style.setProperty('--mc-promo-h', root.offsetHeight + 'px');
      }
      publishHeight();
      window.addEventListener('resize', publishHeight);
      if (window.ResizeObserver) { new ResizeObserver(publishHeight).observe(root); }

      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-ba-root]');
    if (!roots.length) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    roots.forEach(function (root) {
      var stage = root.querySelector('[data-ba]');
      if (!stage) return;
      var handle = root.querySelector('[data-ba-handle]');
      var beforeImg = root.querySelector('[data-ba-before]');
      var afterImg = root.querySelector('[data-ba-after]');
      var media = stage.querySelector('.res-ba__media');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
      var capCat = root.querySelector('[data-cap-cat]');
      var capQuote = root.querySelector('[data-cap-quote]');
      var capAuthor = root.querySelector('[data-cap-author]');

      var data = thumbs.map(function (t) {
        return {
          before: t.getAttribute('data-before'),
          after: t.getAttribute('data-after'),
          cat: t.getAttribute('data-cat'),
          quote: t.getAttribute('data-quote'),
          author: t.getAttribute('data-author')
        };
      });

      // Preload pairs so swaps are instant — but DEFER until the section nears
      // the viewport. This keeps the ~1MB of full-res before/after pairs off the
      // initial critical path (they were starving the hero/LCP on mobile).
      // Purely a timing change: by the time the slider is reached the pairs are
      // prefetched, so switching stays instant and nothing looks different.
      var preloaded = false;
      function preloadAll() {
        if (preloaded) return;
        preloaded = true;
        data.forEach(function (d) {
          if (d.before) { var a = new Image(); a.src = d.before; }
          if (d.after) { var b = new Image(); b.src = d.after; }
        });
      }
      if ('IntersectionObserver' in window) {
        var preIO = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) {
            preIO.disconnect();
            preloadAll();
          }
        }, { rootMargin: '600px 0px' });
        preIO.observe(root);
      } else {
        preloadAll();
      }
      // Belt-and-suspenders: prefetch a pair the instant its thumb is hovered/focused.
      thumbs.forEach(function (t) {
        function pf() {
          var b = t.getAttribute('data-before'), a = t.getAttribute('data-after');
          if (b) { var ib = new Image(); ib.src = b; }
          if (a) { var ia = new Image(); ia.src = a; }
        }
        t.addEventListener('mouseenter', pf, { once: true });
        t.addEventListener('focus', pf, { once: true });
      });

      var current = 0;
      var touched = false;
      var dragging = false;
      var autoplay = root.hasAttribute('data-autoplay') && !reduced && data.length > 1;
      var timer = null;
      var ANIM = null;

      function setPos(p) {
        if (p < 0) p = 0; if (p > 100) p = 100;
        stage.style.setProperty('--pos', p + '%');
        if (handle) handle.setAttribute('aria-valuenow', Math.round(p));
      }

      function posFromEvent(clientX) {
        var r = media.getBoundingClientRect();
        if (!r.width) return 50;
        return ((clientX - r.left) / r.width) * 100;
      }

      function markTouched() {
        if (touched) return;
        touched = true;
        stage.classList.add('is-touched');
        cancelHint();
        stopAuto();
      }

      // Hint sweep: nudge the divider once so users see it's draggable
      function cancelHint() { if (ANIM) { cancelAnimationFrame(ANIM); ANIM = null; } }
      function hintSweep() {
        if (reduced || touched) { setPos(50); return; }
        var start = null, dur = 1100;
        function frame(ts) {
          if (start === null) start = ts;
          var t = (ts - start) / dur;
          if (t >= 1 || touched) { setPos(50); ANIM = null; return; }
          // ease in-out, peak at ~62%
          var e = 0.5 - 0.5 * Math.cos(t * 2 * Math.PI);
          setPos(50 + e * 14);
          ANIM = requestAnimationFrame(frame);
        }
        cancelHint();
        ANIM = requestAnimationFrame(frame);
      }

      function select(i, replayHint) {
        current = (i % data.length + data.length) % data.length;
        var d = data[current];
        media.parentNode.classList.add('is-swapping');
        window.setTimeout(function () {
          if (beforeImg && d.before) { beforeImg.src = d.before; beforeImg.alt = 'Avant — ' + d.cat; }
          if (afterImg && d.after) { afterImg.src = d.after; afterImg.alt = 'Après — ' + d.cat; }
          if (capCat) capCat.textContent = d.cat;
          if (capQuote) capQuote.textContent = d.quote;
          if (capAuthor) capAuthor.textContent = d.author;
          setPos(50);
          media.parentNode.classList.remove('is-swapping');
          if (replayHint && !touched) hintSweep();
        }, reduced ? 0 : 200);

        thumbs.forEach(function (t, ti) {
          var on = ti === current;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      }

      // ── Drag / pointer ──
      function onDown(e) {
        dragging = true;
        markTouched();
        if (handle && handle.focus) { try { handle.focus({ preventScroll: true }); } catch (err) { handle.focus(); } }
        setPos(posFromEvent(e.clientX));
        if (stage.setPointerCapture && e.pointerId != null) {
          try { stage.setPointerCapture(e.pointerId); } catch (err) {}
        }
        e.preventDefault();
      }
      function onMove(e) {
        if (!dragging) return;
        setPos(posFromEvent(e.clientX));
      }
      function onUp() { dragging = false; }

      if (window.PointerEvent) {
        stage.addEventListener('pointerdown', onDown);
        stage.addEventListener('pointermove', onMove);
        stage.addEventListener('pointerup', onUp);
        stage.addEventListener('pointercancel', onUp);
      } else {
        stage.addEventListener('mousedown', onDown);
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onUp);
        stage.addEventListener('touchstart', function (e) { onDown(e.touches[0]); }, { passive: false });
        stage.addEventListener('touchmove', function (e) { onMove(e.touches[0]); }, { passive: true });
        stage.addEventListener('touchend', onUp);
      }

      // Keyboard on the handle
      if (handle) {
        handle.addEventListener('keydown', function (e) {
          var p = parseFloat(handle.getAttribute('aria-valuenow')) || 50;
          if (e.key === 'ArrowLeft') { markTouched(); setPos(p - 4); e.preventDefault(); }
          else if (e.key === 'ArrowRight') { markTouched(); setPos(p + 4); e.preventDefault(); }
          else if (e.key === 'Home') { markTouched(); setPos(0); e.preventDefault(); }
          else if (e.key === 'End') { markTouched(); setPos(100); e.preventDefault(); }
        });
      }

      // ── Thumbnails ──
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          markTouched();
          select(parseInt(t.getAttribute('data-index'), 10) || 0, false);
        });
      });

      // ── Autoplay (pauses on hover / interaction) ──
      function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }
      function startAuto() {
        if (!autoplay || touched || timer) return;
        timer = window.setInterval(function () {
          if (touched) { stopAuto(); return; }
          select(current + 1, true);
        }, 5200);
      }
      if (autoplay) {
        root.addEventListener('pointerenter', stopAuto);
        root.addEventListener('pointerleave', function () { if (!touched) startAuto(); });
      }

      // ── Reveal on scroll: show hint + start autoplay when in view ──
      function activate() {
        stage.classList.add('is-ready');
        if (!touched) { hintSweep(); startAuto(); }
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { activate(); io.disconnect(); }
          });
        }, { threshold: 0.35 });
        io.observe(stage);
      } else {
        activate();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-and-community"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('[data-section-type="reviews-and-community"]');
  sections.forEach(function (section) {
    // Influencer cards: hover plays video, leave pauses
    var cards = section.querySelectorAll('.community-block');
    cards.forEach(function (card) {
      var video = card.querySelector('.community-block__media video');
      if (!video) return;
      card.addEventListener('mouseenter', function () {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      });
      card.addEventListener('mouseleave', function () {
        try { video.pause(); video.currentTime = 0; } catch (e) {}
      });
    });

    // Marquee custom duration
    var marquee = section.querySelector('[data-marquee]');
    if (marquee) {
      var dur = marquee.getAttribute('data-duration');
      if (dur) {
        marquee.querySelectorAll('.marquee__content').forEach(function (c) {
          c.style.setProperty('--reviews-anim-duration', dur + 's');
        });
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["super-pouvoirs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function countUp(el) {
      var target = parseInt(el.getAttribute('data-count'), 10);
      if (isNaN(target)) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { el.textContent = target; return; }
      var dur = 1200, start = null;
      function tick(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        el.textContent = Math.round((1 - Math.pow(1 - p, 3)) * target);
        if (p < 1) requestAnimationFrame(tick); else el.textContent = target;
      }
      requestAnimationFrame(tick);
    }

    function arm(section) {
      if (section.dataset.spBound === '1') return;
      section.dataset.spBound = '1';
      var counter = section.querySelector('[data-sp-count]');
      function reveal() {
        section.classList.add('is-in');
        if (counter) countUp(counter);
      }
      if (!('IntersectionObserver' in window)) { reveal(); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { reveal(); io.unobserve(en.target); }
        });
      }, { threshold: 0.2 });
      io.observe(section);
    }

    function boot() { document.querySelectorAll('[data-section-type="super-pouvoirs"]').forEach(arm); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', function (e) {
      var s = e.target.querySelector('[data-section-type="super-pouvoirs"]');
      if (s) arm(s);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
